/**
 * https://github.com/jayfreestone/priority-plus
 */

import priorityPlus from "priority-plus";

function priorityPlusNav(blockName){
    if(!window.isMobile){
        try {
            const priorityPlusMenu = priorityPlus(document.querySelector(`.${blockName}_list`), {
                classNames: {
                    'toggle-btn': [`${blockName}__link ${blockName}__link_more p-plus__toggle-btn`],
                    'overflow-nav': [`${blockName}__submenu ${blockName}__submenu_level1 ${blockName}__submenu_more`],
                },
                innerToggleTemplate: 'Еще...',
            });

            priorityPlusMenu.on('itemsChanged', priorityPlusMenuClasses);
            priorityPlusMenu.on('toggleClicked', priorityPlusMenuClasses);
            priorityPlusMenuVisible();

            function priorityPlusMenuClasses(){
                // add classes on submenu
                document.querySelectorAll(`.${blockName}__submenu_more li`).forEach((li) => {
                    li.classList.remove(`${blockName}_item`);
                    li.classList.add(`${blockName}__submenu-item`);``

                    const link = li.querySelector('a');
                    if(link){
                        link.classList.remove(`${blockName}__link`);
                        link.classList.add(`${blockName}__submenu-link`);
                    }
                });

                // add classes on menu
                document.querySelectorAll(`.${blockName}_list > .${blockName}__submenu-item`).forEach((li) => {
                    li.classList.remove(`${blockName}__submenu-item`);
                    li.classList.add(`${blockName}_item`);

                    const link = li.querySelector('a');
                    if(link){
                        link.classList.remove(`${blockName}__submenu-link`);
                        link.classList.add(`${blockName}__link`);
                    }
                });
            }

            function priorityPlusMenuVisible(){
                setTimeout(function () {
                    if(blockName === 'menu-header'){
                        document.querySelector(`.header__desktop-top-grid`).classList.add(`header__desktop-top-grid_visible`);

                    }
                    if(blockName === 'menu-top'){
                        document.querySelector(`.${blockName}__container`).classList.add(`${blockName}__container_visible`);
                    }
                }, 100);
            }
        } catch (err) {
            console.log(err);
        }
    }
}

export default priorityPlusNav;